import React, { useState } from 'react';
import { Section } from './ui/Section';
import { ChevronDown, ChevronUp } from 'lucide-react';
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-slate-200 last:border-0" data-id="element-39">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-40">
        <span className="font-medium text-slate-900" data-id="element-41">{question}</span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-slate-400" data-id="element-42" /> : <ChevronDown className="w-5 h-5 text-slate-400" data-id="element-43" />}
      </button>
      {isOpen && <div className="pb-4 text-slate-600 text-sm leading-relaxed animate-in fade-in slide-in-from-top-1 duration-200" data-id="element-44">
          {answer}
        </div>}
    </div>;
}
export function FAQSection() {
  const faqs = [{
    question: '¿Cuánto tarda?',
    answer: 'Empiezas con cambios desde la primera noche, y sigues el plan de 14 noches.'
  }, {
    question: '¿Necesito comprar cosas?',
    answer: 'No. Hay opciones con lo que ya tienes. Si decides comprar algo (sábanas, antifaz), es opcional.'
  }, {
    question: '¿Sirve si tengo ansiedad?',
    answer: 'Está diseñado para bajar activación. Si tu ansiedad es intensa o hay ataques de pánico, úsalo como apoyo y considera atención profesional.'
  }, {
    question: '¿Y si me despierto igual?',
    answer: 'El objetivo inicial es que el despertar dure menos y que tu cuerpo aprenda el camino de regreso.'
  }];
  return <Section background="white" data-id="element-45">
      <h2 className="text-2xl font-serif font-bold text-slate-900 mb-8 text-center" data-id="element-46">
        Preguntas Frecuentes
      </h2>
      <div className="max-w-xl mx-auto" data-id="element-47">
        {faqs.map((faq, idx) => <FAQItem key={idx} {...faq} data-id="element-48" />)}
      </div>
    </Section>;
}